import { createSlice } from "@reduxjs/toolkit";
import { STATE_NAMES } from "./StateNames";

export enum COMPLETED_PROJECTS_PAGE {
    PER_PAGE = 'perPage',
    SORT_BY = 'sortBy',
}

const CompletedProjectsPageSlice = createSlice({
    name: STATE_NAMES.COMPLETED_PROJECTS_PAGE,
    initialState: {
        [COMPLETED_PROJECTS_PAGE.PER_PAGE]: null,
        [COMPLETED_PROJECTS_PAGE.SORT_BY]: null,
    },
    reducers: {
        setCompletedProjectsPerPage: (state, action) => {
            state[COMPLETED_PROJECTS_PAGE.PER_PAGE] = action.payload;
        },
        setCompletedProjectsSortBy: (state, action) => {
            state[COMPLETED_PROJECTS_PAGE.SORT_BY] = action.payload;
        },
    },
    selectors: {
        getCompletedProjectsPerPage: state => state[COMPLETED_PROJECTS_PAGE.PER_PAGE],
        getCompletedProjectsSortBy: state => state[COMPLETED_PROJECTS_PAGE.SORT_BY],
    }
})

export const {
    setCompletedProjectsPerPage,
    setCompletedProjectsSortBy
} = CompletedProjectsPageSlice.actions;
export const {
    getCompletedProjectsPerPage,
    getCompletedProjectsSortBy
} = CompletedProjectsPageSlice.selectors;

export default CompletedProjectsPageSlice.reducer;
